<template>
  <section>
    <div class="role">
      <div class="roleRight">
        <div class="roleRight_Top" style="display: block">
          <template v-if="searchShow">
            <el-input
                clearable
                v-model="search.name"
                class="input_search"
                placeholder="搜索分类名称"
                style="margin-bottom: 10px;margin-right: 10px"
                @keyup.enter.native="SearchServiceList"
            ></el-input>

            <el-select
                v-model="search.isOffline"
                clearable
                filterable
                placeholder="分类状态"
                style="margin-bottom: 10px;margin-right: 10px"
            >
              <el-option
                  v-for="item in CATEGORY_STATUS"
                  :key="item.key"
                  :label="item.name"
                  :value="item.key"
              ></el-option>
            </el-select>

            <el-button size="medium" type="primary" @click="SearchServiceList"
            >查询</el-button
            >
            <el-button size="medium" @click="handleReset"
            >重置</el-button
            >
          </template>
          <el-button v-if="addShow" size="medium" type="primary" @click="handleAdd"
          >新增分类</el-button
          >
        </div>
        <div class="roleRight_Container public-table-data">
          <el-table
            :data="tableData"
            size="medium"
            border
            style="width: 100%"
            v-loading="loading"
          >
            <el-table-column fixed label="序号" type="index" width="80">
              <template slot-scope="scope">
                <span>{{ (page.pageNo - 1) * page.pageSize + scope.$index + 1 }}</span>
              </template>
            </el-table-column>

            <el-table-column label="图标" width="80" align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.icon" style="text-align: center;">
                  <img :src="scope.row.icon" alt="图标" style="width: 40px; height: 40px; object-fit: cover; border-radius: 4px;">
                </div>
                <div v-else style="color: #ccc;">-</div>
              </template>
            </el-table-column>

            <el-table-column label="分类信息" min-width="300">
              <template slot-scope="scope">
                <div style="text-align: left;">
                  <div style="font-weight: bold; font-size: 14px; margin-bottom: 5px;">
                    {{ scope.row.name || '-' }}
                  </div>
                  <div style="color: #666; font-size: 12px; margin-bottom: 3px;">
                    ID：{{ scope.row.id || '-' }}
                  </div>
                  <div style="color: #666; font-size: 12px;">
                    描述：{{ scope.row.description || '-' }}
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="状态" width="100">
              <template slot-scope="scope">
                <el-tag :type="scope.row.isOffline === 0 ? 'success' : 'danger'" size="mini">
                  {{ scope.row.isOffline === 0 ? '正常' : '下架' }}
                </el-tag>
              </template>
            </el-table-column>

            <el-table-column label="排序" width="100" align="center">
              <template slot-scope="scope">
                <el-input-number
                  v-model="scope.row.sortOrder"
                  :min="0"
                  :max="9999"
                  size="mini"
                  controls-position="right"
                  @change="handleSortOrderChange(scope.row)"
                  :disabled="!editShow"
                  style="width: 80px;"
                ></el-input-number>
              </template>
            </el-table-column>

            <el-table-column label="上架" width="80" align="center">
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.isOffline"
                  :active-value="0"
                  :inactive-value="1"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  @change="handleOfflineChange(scope.row)"
                  :disabled="!statusShow"
                  size="mini"
                ></el-switch>
              </template>
            </el-table-column>

            <el-table-column label="时间信息" min-width="200">
              <template slot-scope="scope">
                <div style="font-size: 12px;">
                  <div>创建：{{ formatDate(scope.row.ctime) }}</div>
                  <div>更新：{{ formatDate(scope.row.utime) }}</div>
                </div>
              </template>
            </el-table-column>

            <el-table-column fixed="right" label="操作" width="150">
              <template slot-scope="scope">
                <el-button
                  @click="handleEdit(scope.row)"
                  type="text"
                  size="small"
                  v-if="editShow"
                >
                  编辑
                </el-button>
                <el-button
                  @click="handleStatusChange(scope.row)"
                  type="text"
                  size="small"
                  v-if="statusShow"
                >
                  {{ scope.row.isOffline === 0 ? '禁用' : '启用' }}
                </el-button>
                <el-button
                  @click="handleDelete(scope.row)"
                  type="text"
                  size="small"
                  style="color: #f56c6c"
                  v-if="deleteShow"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>

          </el-table>
        </div>

        <div class="roleRight_pagenation">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.pageNo"
            :page-sizes="[PAGE_SIZE, 15, 20, 25]"
            :page-size="page.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="page.count"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 编辑弹窗 -->
    <MultiLanguageEditDialog
      ref="editDialog"
      title="分类编辑"
      detail-api="article/category/detail"
      :api="'/article/category/save'"
      @success="getCategoryList"
    />
  </section>
</template>
<script>
import {
  PAGE_SIZE,
} from "@/config";
import { formatDate } from "@/utils/filters/filter";
import MultiLanguageEditDialog from '@/components/MultiLanguageEditDialog.vue';
import DetailDialog from "@/components/DetailDialog.vue";
import EditDialog from "@/components/EditDialog.vue";

export default {
  components: {
    MultiLanguageEditDialog,
    DetailDialog,
    EditDialog
  },
  data() {
    return {
      PAGE_SIZE,
      formatDate,
      
      // 分类状态选项
      CATEGORY_STATUS: [
        { key: 0, name: '启用' },
        { key: 1, name: '禁用' }
      ],

      // 分页
      page: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
        count: 0
      },
      
      tableData: [], // 分类列表数据
      loading: false,
      search: {},

      // 权限控制
      searchShow: true,
      addShow: true,
      editShow: true,
      deleteShow: true,
      statusShow: true
    };
  },
  created() {
    this.getCategoryList();
    this.getPermissionButtonList();
  },
  methods: {
    // 获取权限按钮列表
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton');
      if (PermissionButtonList) {
        try {
          let arr = JSON.parse(PermissionButtonList);
          // 确保arr是数组
          if (arr && Array.isArray(arr) && arr.length) {
            arr.forEach(item => {
              if (item.code === 'article:category:query') {
                this.searchShow = true;
              }
              if (item.code === 'article:category:add') {
                this.addShow = true;
              }
              if (item.code === 'article:category:edit') {
                this.editShow = true;
              }
              if (item.code === 'article:category:delete') {
                this.deleteShow = true;
              }
              if (item.code === 'article:category:status') {
                this.statusShow = true;
              }
            });
          }
        } catch (error) {
          console.error('权限按钮列表解析失败:', error);
        }
      }
    },

    // 搜索
    SearchServiceList() {
      this.page.pageNo = 1;
      this.getCategoryList();
    },

    // 获取分类列表
    async getCategoryList() {
      this.loading = true;
      try {
        const { data: res } = await this.$post(
          `/article/category/list`,
          { 
            ...this.search, 
            pageNo: this.page.pageNo,
            pageSize: this.page.pageSize
          },
          {
            headers: {
              isLoading: true,
            },
          }
        );
        
        if (res && res.data) {
          this.tableData = res.data||[];
          // 如果返回的数据有分页信息
          if (res.page) {
            this.page.count = res.page.total || res.page.count || 0;
          } else {
            // 如果没有分页信息，设置为数据长度
            this.page.count = res.data.length || 0;
          }
        }else{
          this.tableData = [];
          this.page.count = 0;
        }
      } catch (error) {
        console.error('获取分类列表失败:', error);
        this.$message.error('获取分类列表失败');
      } finally {
        this.loading = false;
      }
    },

    // 新增分类
    handleAdd() {
      if (!this.$refs.editDialog) return;
      this.$refs.editDialog.open({}, this.getBasicColumns(), { api: '/article/category/save', method: 'post' });
    },

    // 编辑分类
    handleEdit(row) {
      if (!this.$refs.editDialog) return;
      this.$refs.editDialog.open(row, this.getBasicColumns(), { api: '/article/category/save', method: 'post' });
    },

    // 删除分类
    async handleDelete(row) {
      try {
        await this.$confirm('确定要删除这个分类吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        
        // 调用删除接口
        await this.$get(`/article/category/delete/${row.id}`);
        this.$message.success('删除成功');
        this.getCategoryList();
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除失败:', error);
          this.$message.error('删除失败');
        }
      }
    },

    // 状态变更
    handleOfflineChange(row) {
      const data = {
        ...row,
        isOffline: row.isOffline
      };
      
      this.api.post('/article/category/save', data).then(res => {
        if (res.code === 200) {
          this.$message.success('状态更新成功');
          this.getCategoryList();
        } else {
          this.$message.error(res.msg || '状态更新失败');
          // 恢复原状态
          row.isOffline = row.isOffline === 0 ? 1 : 0;
        }
      }).catch(error => {
        console.error('状态更新失败:', error);
        this.$message.error('状态更新失败');
        // 恢复原状态
        row.isOffline = row.isOffline === 0 ? 1 : 0;
      });
    },

    // 排序变更
    handleSortOrderChange(row) {
      const data = {
        ...row,
        sortOrder: row.sortOrder
      };
      
      this.api.post('/article/category/save', data).then(res => {
        if (res.code === 200) {
          this.$message.success('排序更新成功');
          this.getCategoryList();
        } else {
          this.$message.error(res.msg || '排序更新失败');
        }
      }).catch(error => {
        console.error('排序更新失败:', error);
        this.$message.error('排序更新失败');
      });
    },

    // 分页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getCategoryList();
    },
    
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getCategoryList();
    },

    // 重置搜索条件
    handleReset() {
      this.search = {};
      this.page.pageNo = 1;
      this.getCategoryList();
    },

    getBasicColumns() {
      return [
        // { label: 'ID', prop: 'id', type: 'text', addHide: true },
        { label: '分类名称', prop: 'name', type: 'text', required: true },
        { label: '分类图标', prop: 'icon', type: 'image' },
        { label: '分类描述', prop: 'description', type: 'textarea' },
        { label: '排序', prop: 'sortOrder', type: 'number' },
        { label: '是否下架', prop: 'isOffline', type: 'switch' },
        { label: '创建时间', prop: 'createTime', type: 'date', hide: true, addHide: true, editHide: true },
        { label: '更新时间', prop: 'updateTime', type: 'date', hide: true, addHide: true, editHide: true }
      ];
    }
  },
};
</script>

<style lang="scss" scoped>
.role {
  display: flex;
  gap: 20px;
  color: #666; /** 公共的黑色 --暂定 */
  font-size: 14px;
  &Right {
    flex: 1;
    display: flex;
    overflow-x: hidden;
    flex-direction: column;
    &_Top {
      display: flex;
      gap: 15px;
      .el-input {
        width: auto;
      }
      .timeblock {
        display: flex;
        box-sizing: border-box;
        background: #fff;
        border: 1px solid #dcdfe6;
        border-radius: 5px;
        .cla ::v-deep .el-input--suffix .el-input__inner {
          padding-right: 0;
        }
        ::v-deep .el-input__inner {
          border: none !important;
          height: 38px;
        }
      }
    }
    &_Container {
      margin-top: 20px;
    }
    &_pagenation {
      margin: 40px auto;
    }

    ::v-deep .el-table th,
    ::v-deep .el-table td {
      text-align: center !important;
    }
  }
}
</style>